import {
  addDays,
  addMonths,
  endOfDay,
  endOfMonth,
  endOfWeek,
  endOfYear,
  startOfDay,
  startOfMonth,
  startOfWeek,
  startOfYear,
} from 'date-fns'
import { isSameDay } from 'date-fns'

const currentYear = new Date().getFullYear()

const getMonthName = (date: Date): string => {
  const monthNames = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ]
  return monthNames[date.getMonth()]
}

const getPreviousMonthName = (date: Date): string => {
  const previousMonth = addMonths(date, -1)
  return getMonthName(previousMonth)
}

export const DEFINEDS = {
  startOfWeek: startOfWeek(new Date()),
  endOfWeek: endOfWeek(new Date()),
  startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
  endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
  startOfToday: startOfDay(new Date()),
  endOfToday: endOfDay(new Date()),
  startOfCurrent: startOfDay(addDays(new Date(), -14)),
  endOfCurrent: endOfDay(addDays(new Date(), 14)),
  startOfMonth: startOfMonth(new Date()),
  endOfMonth: endOfMonth(new Date()),
  startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
  endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
  startOfYear: (year: number) => startOfYear(new Date(year, 0, 1)),
  endOfYear: (year: number) => endOfYear(new Date(year, 0, 1)),
}

// Проверка совпадения выбранного диапазона с заданными датами
const isSelectedRange = (
  range: { startDate?: Date; endDate?: Date } | any,
  start: Date,
  end: Date
): boolean => {
  if (!range?.startDate || !range?.endDate) return false
  return isSameDay(range.startDate, start) && isSameDay(range.endDate, end)
}

const getCurrentTwoWeeksWindow = () => ({
  start: DEFINEDS.startOfCurrent,
  end: DEFINEDS.endOfCurrent,
})

export const staticRangesArray = [
  {
    label: 'Текущие',
    isSelected: (range: any) => {
      const { start, end } = getCurrentTwoWeeksWindow()
      return isSelectedRange(range, start, end)
    },
    range: () => {
      const { start, end } = getCurrentTwoWeeksWindow()
      return { startDate: start, endDate: end }
    },
  },
  {
    label: getMonthName(new Date()), // Текущий месяц
    isSelected: (range: any) =>
      isSelectedRange(range, DEFINEDS.startOfMonth, DEFINEDS.endOfMonth),
    range: () => ({
      startDate: DEFINEDS.startOfMonth,
      endDate: DEFINEDS.endOfMonth,
    }),
  },
  {
    label: getPreviousMonthName(new Date()), // Предыдущий месяц
    isSelected: (range: any) =>
      isSelectedRange(
        range,
        DEFINEDS.startOfLastMonth,
        DEFINEDS.endOfLastMonth
      ),
    range: () => ({
      startDate: DEFINEDS.startOfLastMonth,
      endDate: DEFINEDS.endOfLastMonth,
    }),
  },
  ...[0, 1].map((offset) => {
    const year = currentYear - offset
    return {
      label: `${year}`,
      isSelected: (range: any) =>
        isSelectedRange(
          range,
          DEFINEDS.startOfYear(year),
          DEFINEDS.endOfYear(year)
        ),
      range: () => ({
        startDate: DEFINEDS.startOfYear(year),
        endDate: DEFINEDS.endOfYear(year),
      }),
    }
  }),
]
